<template>
  <div class="card">
        <h5>Edit Product</h5>
        <hr>
        
        <div class="container p-0 m-0">
          <div class="row mb-2">
            <CurrencyInput 
              class="col" 
              placeholder="" 
              label="Price" 
              v-model="product.CustomerCost"
              :validator="$v.product.CustomerCost"
              :validatorMsgMap="CustomerCostMsgMap"/>
          </div>
          <div class="row mb-2">
            <CurrencyInput 
              class="col" 
              placeholder="" 
              label="Max Price" 
              v-model="product.MaximumPrice"
              :validator="$v.product.MaximumPrice"
              :validatorMsgMap="MaximumPriceMsgMap"/>
          </div>
          <div class="row mb-2">
            <CurrencyInput 
              class="col" 
              placeholder="" 
              label="Min Price" 
              v-model="product.MinimumPrice"
              :validator="$v.product.MinimumPrice"
              :validatorMsgMap="MinimumPriceMsgMap"/>
          </div>
          
        </div>
        <button type="button" class="btn btn-primary" @click="saveProduct">Save</button>

      </div>
</template>

<script>
import { validatorMsgMapBase } from "../modules/helpers";
import {
    required,
    minValue,
    maxValue
} from 'vuelidate/lib/validators';

import {ProductService} from '@/services';
export default {
  name: 'EditProductForm',
  props:{
    value:{
      type: Object,
      default: () => {
        //fill in customerdetails
      }
    },
  },
  data(){
    return{
      validatorMsgMapBase: validatorMsgMapBase,
      product: this.value
    }
  },
  validations() {
    return {
      product: {
        CustomerCost: {
          required,
          minValue: minValue(this.product.MinimumPrice),
          maxValue: maxValue(this.product.MaximumPrice)
        },
        MaximumPrice: {
          minValue: minValue(this.product.MinimumPrice)
        },
        MinimumPrice: {
          maxValue: maxValue(this.product.MaximumPrice)
        }
      }
    }
  },
  methods: {
    saveProduct(){
      this.$v.product.$touch();
      if (this.$v.product.$invalid){
          this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
          return;
      }
      let newProductPrices = this.getNewProductValues();
      ProductService.update(newProductPrices)
        .then(res => {
          this.$emit('closeProductEdit')
        })
        .catch(err => {
          console.log(err)
        })
      
    },
    getNewProductValues(){
      let newValues = {
        Id: this.product.Id,
        CustomerCost: this.product.CustomerCost.toFixed(2),
        MaximumPrice: this.product.MaximumPrice.toFixed(2),
        MinimumPrice: this.product.MinimumPrice.toFixed(2),
      }
      return newValues
    },
  },
  computed: {
    CustomerCostMsgMap(){
      return {
        ...this.validatorMsgMapBase,
        required: 'Customer Cost is Required',
        minValue: `The minimum price is set to ${this.product.MinimumPrice}`,
        maxValue: `The maximum price is set to ${this.product.MaximumPrice}`
      };
    },
    MaximumPriceMsgMap(){
      return {...this.validatorMsgMapBase,
        minValue:      `The minimum price is set to ${this.product.MinimumPrice}`
      };
    },
    MinimumPriceMsgMap(){
      return {...this.validatorMsgMapBase,
        maxValue:      `The maximum price is set to ${this.product.MaximumPrice}`
      };
    }
  },

}
</script>

<style lang="scss" scoped>
  .card{ 
    width: 400px;
    padding: 25px;
    .modal-card {
      background-color: white;
    }
  }
</style>